<template>
  <div class="others" style="padding: 0 1em; text-align: left;">
    <div v-html="content"/>
  </div>
</template>

<script>
export default {
  name: 'inquiry',
  data () {
    return {
      content: ''
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
  },
  created () {
    var vm = this
    this.$http
        .get('./WebApi/Apply/GetFormatInfo/'.concat(this.sysId).concat('/1/6'))
        .then(function(response) {
          vm.content = response.data
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗');
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/InquiryView.vue